import Layout from 'antd/lib/layout/layout';
import { Outlet } from 'react-router-dom';

import Header from 'components/Header';
import Menu from 'components/Menu';

import * as Styled from './Home.styles';

const Home = () => (
  <Layout>
    <Header />
    <Layout style={{ height: 'calc(100vh - 80px)', overflow: 'hidden' }}>
      <Styled.Sider width={300}>
        <Menu />
      </Styled.Sider>
      <Styled.Content>
        <Outlet />
      </Styled.Content>
    </Layout>
  </Layout>
);

export default Home;
